// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Labels_text-gradient__Aw-cR","labels":"Labels_labels__Z3pTF","button":"Labels_button__3G1wq"};